import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { INTELLIGENCE_DEBUG_ASK } from '../../apiServices/api_routes';

/**
 * Internal-only intelligence debug playground (staff / INTELLIGENCE_DEBUG).
 * Not customer-facing.
 */
const IntelligenceDebugPage = () => {
    const projectId = useSelector(state => state.project?.project?.id);
    const [question, setQuestion] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    const onSubmit = useCallback(
        async e => {
            e.preventDefault();
            if (!projectId || !question.trim()) return;
            setLoading(true);
            setError(null);
            try {
                const { data } = await axios.post(INTELLIGENCE_DEBUG_ASK(projectId), {
                    question: question.trim(),
                    accuracy_mode: true,
                });
                setResult(data);
            } catch (err) {
                setError(err?.response?.data?.detail || err.message || 'Debug ask failed');
                setResult(null);
            } finally {
                setLoading(false);
            }
        },
        [projectId, question],
    );

    if (!projectId) {
        return <p>Select a project to use the intelligence debug playground.</p>;
    }

    const panel = result?.debug_panel || {};

    return (
        <div style={{ padding: 24, maxWidth: 960 }}>
            <h2>Intelligence Debug Playground</h2>
            <p style={{ color: '#666' }}>Internal tool — shows route, tools, evidence, prompt, and trace.</p>
            <form onSubmit={onSubmit}>
                <textarea
                    rows={3}
                    style={{ width: '100%', marginBottom: 8 }}
                    value={question}
                    onChange={e => setQuestion(e.target.value)}
                    placeholder="Ask a question…"
                />
                <button type="submit" disabled={loading || !question.trim()}>
                    {loading ? 'Running…' : 'Debug Ask'}
                </button>
            </form>
            {error && <pre style={{ color: 'crimson', marginTop: 16 }}>{error}</pre>}
            {result && (
                <div style={{ marginTop: 24 }}>
                    <h3>Answer</h3>
                    <p>{result.answer}</p>
                    <h3>Debug panel</h3>
                    <pre style={{ background: '#f5f5f5', padding: 12, overflow: 'auto', fontSize: 12 }}>
                        {JSON.stringify(
                            {
                                trace_id: result.trace_id,
                                intent: panel.intent,
                                complexity: panel.complexity,
                                route: panel.route,
                                tools_executed: panel.tools_executed,
                                prompt: panel.prompt,
                                model: panel.model,
                                tokens: panel.tokens,
                                latency_ms: panel.latency_ms,
                            },
                            null,
                            2,
                        )}
                    </pre>
                    <details>
                        <summary>Full execution trace</summary>
                        <pre style={{ background: '#f5f5f5', padding: 12, overflow: 'auto', fontSize: 11 }}>
                            {JSON.stringify(panel.execution_trace || result.retrieval_debug, null, 2)}
                        </pre>
                    </details>
                </div>
            )}
        </div>
    );
};

export default IntelligenceDebugPage;
